import React from 'react';

const Welcome = () => {
    return (
        <div>
            <h1 className=' tracking-widest text-3xl md:text-4xl sp-style font-bold text-amber-900 text-center mt-20'>WelCome To <span className='text-cyan-900 sp-style text-8xl '>Sp</span><span className='text-3xl text-cyan-600 '>Deckar</span></h1>
        </div>
    );
};

export default Welcome;